import { useMemo } from 'react'

import { DndContext, MeasuringStrategy, closestCenter } from '@dnd-kit/core'
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers'
import {
  SortableContext,
  horizontalListSortingStrategy
} from '@dnd-kit/sortable'
import { transformAppConfigToAppData } from 'shared/components/MainLayout/components/AppButton/utils/appDataTransform'
import { AppConfig } from 'shared/types/app'

import styles from '../../TopDock.module.scss'
import { SortableAppButton } from '../SortableAppButton'
import { AppGroupProps } from './AppGroup.types'

export const AppGroup = ({
  group,
  apps,
  appIndexMap,
  sensors,
  onDragEnd,
  handleAppClick,
  iconRefs,
  scrollButtonIntoView,
  isLoading
}: AppGroupProps) => {
  const appIds = useMemo(
    () =>
      apps.map((app: AppConfig) => {
        const appData = transformAppConfigToAppData(app)
        return appData.id
      }),
    [apps]
  )

  if (apps.length === 0) return null

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      measuring={{
        droppable: {
          strategy: MeasuringStrategy.Always
        }
      }}
      modifiers={[restrictToHorizontalAxis]}
      onDragEnd={event => onDragEnd(event, group, apps)}
    >
      <SortableContext items={appIds} strategy={horizontalListSortingStrategy}>
        <div className={styles.groupWrapper}>
          {apps.map(app => {
            const index = appIndexMap.get(app.name) ?? -1

            return (
              <SortableAppButton
                key={app.name!}
                app={app}
                index={index}
                handleAppClick={handleAppClick}
                iconRefs={iconRefs}
                scrollButtonIntoView={scrollButtonIntoView}
                isLoading={isLoading}
              />
            )
          })}
        </div>
      </SortableContext>
    </DndContext>
  )
}
